/** Deve refletir config/classificacao_semed.php (slug => rótulo). */
export default [
	{ slug: 'orientacoes-informacoes', titulo: 'ORIENTAÇÕES/INFORMAÇÕES' },
	{ slug: 'agente-administrativo', titulo: 'CARGO AGENTE ADMINISTRATIVO' },
	{ slug: 'assistente-pedagogico-educacao-infantil', titulo: 'CARGO ASSISTENTE PEDAGÓGICO – EDUCAÇÃO INFANTIL' },
	{ slug: 'auxiliar-de-servicos-gerais', titulo: 'CARGO AUXILIAR DE SERVIÇOS GERAIS' },
	{ slug: 'inspetor-de-alunos', titulo: 'CARGO INSPETOR DE ALUNOS' },
	{ slug: 'merendeira', titulo: 'CARGO MERENDEIRA' },
	{ slug: 'monitor-de-transporte-escolar', titulo: 'CARGO MONITOR DE TRANSPORTE ESCOLAR' },
	{ slug: 'motorista-de-transporte-escolar', titulo: 'CARGO MOTORISTA DE TRANSPORTE ESCOLAR' },
	{ slug: 'motorista-i', titulo: 'CARGO MOTORISTA I' },
	{ slug: 'professor-1-ao-5-ensino-fundamental', titulo: 'CARGO PROFESSOR 1º AO 5º ENSINO FUNDAMENTAL' },
	{ slug: 'professor-arte', titulo: 'CARGO PROFESSOR ARTE' },
	{ slug: 'professor-de-aee-sala-de-recursos', titulo: 'CARGO PROFESSOR DE AEE – SALA DE RECURSOS' },
	{ slug: 'professor-de-ciencias-da-natureza', titulo: 'CARGO PROFESSOR DE CIÊNCIAS DA NATUREZA' },
	{ slug: 'professor-de-educacao-fisica', titulo: 'CARGO PROFESSOR DE EDUCAÇÃO FÍSICA' },
	{ slug: 'professor-de-educacao-infantil', titulo: 'CARGO PROFESSOR DE EDUCAÇÃO INFANTIL' },
	{ slug: 'professor-de-geografia', titulo: 'CARGO PROFESSOR DE GEOGRAFIA' },
	{ slug: 'professor-de-historia', titulo: 'CARGO PROFESSOR DE HISTÓRIA' },
	{ slug: 'professor-de-lingua-estrangeira-ingles', titulo: 'CARGO PROFESSOR DE LÍNGUA ESTRANGEIRA - INGLÊS' },
	{ slug: 'professor-de-lingua-portuguesa', titulo: 'CARGO PROFESSOR DE LÍNGUA PORTUGUESA' },
	{ slug: 'professor-de-matematica', titulo: 'CARGO PROFESSOR DE MATEMÁTICA' },
	{ slug: 'psicologo', titulo: 'CARGO PSICÓLOGO' },
	{ slug: 'vigia', titulo: 'CARGO VIGIA' },
]
